<template>
<div v-if="contact">
  <v-card elevation="0" class="mx-auto">
    <v-card-title class="text-h3" v-if="disclaimerAccepted">Ihre Angaben</v-card-title>
    <v-card-title class="text-h3" v-else>Bitte vervollständigen Sie Ihre Angaben</v-card-title>

    <v-card-text class="mb-4">
      <contact-form ref="contactForm"></contact-form>
    </v-card-text>

    <v-card-actions class="flex-wrap">
      <v-btn color="primary" large dark @click="save" :loading="loading">{{ $t("Änderungen speichern") }}</v-btn>
      <!--
      <v-spacer></v-spacer>
      <v-btn color="error" large dark @click="onDeleteAccount">{{ $t("Konto löschen") }}</v-btn>
      -->
    </v-card-actions>
  </v-card>

  <confirm v-model="confirm" title="Konto löschen">
    <template>
      {{ $t("Möchten Sie Ihr Konto mit allen Daten wirklich löschen?") }}
    </template>
  </confirm>
</div>
<div v-else>
  <v-card elevation="0" class="mx-auto">
    <v-card-title>Ungültiger Benutzer</v-card-title>
  </v-card>
</div>
</template>

<script>
import ContactForm from "./ContactForm";
import Confirm from "./utils/Confirm";

export default {
  name: "Account",

  components: {
    ContactForm,
    Confirm
  },

  data() {
    return {
      confirm: false
    }
  },

  computed: {
    disclaimerAccepted() {
      return this.$store.getters["contact/disclaimerAccepted"];
    },

    loading() {
      return this.$store.state.loading;
    },

    contact() {
      if (this.$store.state.contact.contact.email) {
        return true;
      }

      return false;
    }
  },

  methods: {
    save() {
      const valid = this.$refs.contactForm.validate();
      if (valid) {
        this.$store.dispatch("contact/save", this.$refs.contactForm.contact).then(() => {
          if (this.disclaimerAccepted) {
            this.close();
          }
        });
      }
    },

    close() {
      this.$store.commit("userDialog", null);
    },

    deleteAccount() {
    },

    onDeleteAccount(savedSearch) {
      this.confirm = {
        ok: () => {
          console.log("Todo Daten löschen");
        }
      };
    }
  }
};
</script>
